export default __webpack_public_path__ + "static/media/HOAKS-TOOLS-4.b7220838.png";